import { render, staticRenderFns } from "./AutoPostBoostingMatchingResults.vue?vue&type=template&id=3f9b6d9c&scoped=true&"
import script from "./AutoPostBoostingMatchingResults.vue?vue&type=script&lang=ts&"
export * from "./AutoPostBoostingMatchingResults.vue?vue&type=script&lang=ts&"
import style0 from "./AutoPostBoostingMatchingResults.vue?vue&type=style&index=0&id=3f9b6d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9b6d9c",
  null
  
)

export default component.exports